import { AbstractControl, ValidationErrors } from "@angular/forms";
import { isLowercase as CVisLowercase } from 'class-validator';

export const isLowercase = (control: AbstractControl): ValidationErrors | null => {
    return control.value !== "" && !CVisLowercase(control.value) ? { lowercase: 'invalid' } : null;
}